import React from "react"
import CloseModal from "../CloseModal"
import DragDropArea from "../DragDropArea"
import Loader from "../ui/loader"
import { Button } from "../ui/button"
import { CoachPrivateProfileContext } from "../../pages/manage-business/profile/context/coachPrivateProfileContext"
import { CommonFunctionCtx } from "../../context/commonFunctionContext"
import { ProfileRequests } from "../../api/app.service"
import {
  SvgCheckbox,
  SvgCheckboxOff,
  SvgHelp,
  SvgArrowLeftRight,
} from "../icons"
import { useToast } from "../../hooks/useToast"
interface Props {
  handleClick: any
  updateBento: (
    bentoSpot: number,
    selection: string,
    contentId?: number,
    content?: string,
    url?: string
  ) => void
  bentoSelection: number
}

export default function BentoTestimonialFlow({
  handleClick,
  updateBento,
  bentoSelection,
}: Props) {
  const { setPopupNotification } = React.useContext(CommonFunctionCtx)
  const [testimonialImageFile, setTestimonialImageFile] = React.useState<File>()
  const [testimonialImageProperties, setTestimonialImageProperties] =
    React.useState<any>({
      base64: "",
      type: "",
    })
  const [previewImgUrl, setPreviewImgUrl] = React.useState<string>("")
  const [testimonials, setTestimonials] = React.useState<any[]>([])
  const { coachPublicProfileData } = React.useContext(
    CoachPrivateProfileContext
  )
  const { toast } = useToast()
  const [selectedTestimonial, setSelectedTestimonial] =
    React.useState<any>(null)
  const [isLoading, setIsLoading] = React.useState<boolean>(false)

  const validateFile = (imageFile: File) => {
    if (
      (imageFile.type === "image/png" ||
        imageFile.type === "image/jpg" ||
        imageFile.type === "image/jpeg") &&
      imageFile.size <= 5000000 &&
      imageFile.size > 0
    ) {
      return true
    } else {
      return false
    }
  }

  const getTestimonialImageProperties = () => {
    if (testimonialImageFile) {
      if (validateFile(testimonialImageFile)) {
        const type = testimonialImageFile.type.split("/")[1]
        const reader = new FileReader()
        reader.readAsDataURL(testimonialImageFile)
        reader.onload = function () {
          const string = (reader.result as string).split("\n").map((data) => {
            return data.split(",")
          })
          const base64 = string[0][1]
          setTestimonialImageProperties({ base64: base64, type: type })
        }
        reader.onerror = function (error) {
          console.log("Error: ", error)
        }
      } else {
        setPopupNotification({
          show: true,
          title: "Bummer! Your file is too big.",
          message:
            "Give it another try with a file under 5 megabytes, and in one of the following formats: png, jpg, or jpeg.",
          callback: null,
        })
        setTestimonialImageFile(undefined)
        setTestimonialImageProperties({ base64: "", type: "" })
      }
    }
  }

  React.useEffect(() => {
    getTestimonialImageProperties()
    if (testimonialImageFile) {
      setPreviewImgUrl(URL.createObjectURL(testimonialImageFile))
    }
  }, [testimonialImageFile])

  const getCoachTestimonials = () => {
    setIsLoading(true)
    ProfileRequests.getTestimonials({
      coach_public_profile_id: coachPublicProfileData?.coach_public_profile_id,
    })
      .then((data: any) => {
        const allTestimonials = data.testimonials
        const isShownTestimonials = allTestimonials.filter(
          (testimonial: any) => testimonial.is_shown === 1
        )
        setTestimonials(isShownTestimonials)
        setIsLoading(false)
      })
      .catch((ex: any) => {
        console.error(ex)
        toast.error(ex.response.data.message)
      })
  }

  React.useEffect(() => {
    getCoachTestimonials()
  }, [coachPublicProfileData])

  return (
    <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center zoee-backdrop-filter z-[1009]">
      <div className="w-[775px] max-w-[90%] main-shadow rounded-[16px] pt-[76px] pb-[40px] mt-[90px] px-[16px] md:px-[55px] md:min-h-[70vh] max-h-[85vh] bg-white fixed flex flex-col items-center overflow-y-auto">
        <CloseModal
          callback={() => {
            handleClick("cancel")
          }}
          styling="absolute top-[24px] right-[32px] flex items-center justify-center w-[32px] h-[32px] rounded-full bg-grayFlash"
        />
        <h2 className="text-center top-[10px] left-[10px] sm:left-[30px] sm:top-[30px] md:left-[50px] text-[16px] md:text-[28px] lg:text-[16px] sm:mt-0">
          Featured Content
        </h2>
        <div className="flex gap-x-2 justify-center items-center">
          <SvgHelp height="40" width="40" />
          <p className="font-bold text-[20px] sm:mt-4 md:-translate-y-2">
            Testimonial
          </p>
        </div>
        <Button
          variant={"link"}
          onClick={() => {
            handleClick("switch content")
          }}
        >
          <SvgArrowLeftRight />
          Switch content type
        </Button>

        <div className="flex flex-col justify-center items-center mt-4 w-full">
          <div className="flex flex-col gap-[8px] w-full">
            <div className="flex items-center justify-between gap-[8px]">
              <p className="font-bold text-[16px]">Testimonial image</p>
              <span className="font-normal text-sm text-graySlate">
                Optional
              </span>
            </div>
            <DragDropArea
              styling={`w-full rounded-[16px] flex-row h-[100px]`}
              mediaFile={testimonialImageFile}
              setMediaFile={setTestimonialImageFile}
              mediaType="image"
            />
          </div>
          <div className="flex flex-col justify-center items-center rounded-[16px] mt-4">
            {previewImgUrl ? (
              <div className="w-[200px] rounded-[16px] h-[200px]">
                <img
                  src={previewImgUrl}
                  alt="preview"
                  className="w-full h-full rounded-[16px] object-cover"
                />
              </div>
            ) : (
              <p className="text-graySlate text-center text-sm min-w-[300px] mb-5">
                Max file size is 5MB. Recommended 300 x 300 px at 150 DPI.{" "}
                <br />
                File types: .png, .jpg, and .jpeg
              </p>
            )}
            <p className="text-blurple text-center">
              Don't have an image for your testimonial?
            </p>
            <p className="text-blurple text-center">
              Get a free stock photo here{" "}
              <a
                href="https://pixabay.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://pixabay.com
              </a>
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-2 justify-center items-center mt-4 w-full gap-y-4 h-full overflow-auto">
          {testimonials.length > 0 ? (
            <>
              {testimonials.map((testimonial: any, index) => {
                return (
                  <div
                    className="self-start hover:cursor-pointer"
                    key={index}
                    onClick={() => {
                      setSelectedTestimonial(testimonial)
                    }}
                  >
                    <div className="flex gap-x-6">
                      {selectedTestimonial === testimonial ? (
                        <>
                          <SvgCheckbox />
                        </>
                      ) : (
                        <>
                          <SvgCheckboxOff className="border border-[gray] rounded-md" />
                        </>
                      )}
                      <p className="text-md truncate md:max-w-[600px] max-w-[250px]">
                        <b>
                          {testimonial.client_name
                            ? testimonial.client_name
                            : "Anonymous"}
                        </b>
                        <br />
                        {testimonial.testimonial}
                      </p>
                    </div>
                  </div>
                )
              })}
            </>
          ) : (
            <>
              <div
                className={`h-full flex flex-col items-center justify-center gap-y-8`}
              >
                {isLoading ? (
                  <Loader />
                ) : (
                  <p className="text-graySlate text-md text-center">
                    No client testimonials available.
                  </p>
                )}
              </div>
            </>
          )}
        </div>
        <div className="flex gap-x-2 mt-auto">
          <Button
            className="mt-8"
            size="lg"
            variant="outline"
            onClick={() => {
              handleClick("cancel")
            }}
          >
            Cancel
          </Button>

          <Button
            className="mt-8"
            size="lg"
            variant="default"
            onClick={() => {
              updateBento(
                bentoSelection,
                "testimonial",
                selectedTestimonial.id,
                undefined,
                testimonialImageProperties?.base64
                  ? `data:image/${testimonialImageProperties.type};base64,${testimonialImageProperties.base64}`
                  : undefined
              )
            }}
            disabled={!selectedTestimonial}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  )
}
